import React from "react";
import I18nProvider from "@/i18n/I18nProvider";
import BillingAnalyticsTracker from "@/components/analytics/BillingAnalyticsTracker";
import PostHogIdentifyTracker from "@/components/analytics/PostHogIdentifyTracker";

/**
 * Authenticated product shell. Loaded only off the auth flow so signup and
 * login do not download page catalogs, billing analytics, or PostHog identify.
 */
export default function AppProductShell({
  children
}: {
  children: React.ReactNode;
}) {
  return <I18nProvider data-sentry-element="I18nProvider" data-sentry-component="AppProductShell" data-sentry-source-file="AppProductShell.tsx">
            <BillingAnalyticsTracker data-sentry-element="BillingAnalyticsTracker" data-sentry-source-file="AppProductShell.tsx" />
            <PostHogIdentifyTracker data-sentry-element="PostHogIdentifyTracker" data-sentry-source-file="AppProductShell.tsx" />
            {children}
        </I18nProvider>;
}